<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-logo">
        <img :src="Images.LOGO" alt="Logo">
      </div>
      <ul class="navbar-nav">
        <li class="nav-item" :class="{ 'active': activeNav === 'home' }" @click="setActiveNav('home')">
          <router-link to="/home" class="nav-link">首页</router-link>
        </li>

        <li class="nav-item" :class="{ 'active': activeNav === 'products' }" @click="setActiveNav('products')">
          <router-link to="/products" class="nav-link">产品与服务</router-link>
        </li>
        <li class="nav-item" :class="{ 'active': activeNav === 'news' }" @click="setActiveNav('news')">
          <router-link to="/news" class="nav-link">新闻中心</router-link>
        </li>
        <li class="nav-item" :class="{ 'active': activeNav === 'about' }" @click="setActiveNav('about')">
          <router-link to="/about" class="nav-link">关于我们</router-link>
        </li>
        <li class="nav-item" :class="{ 'active': activeNav === 'contact' }" @click="setActiveNav('contact')">
          <router-link to="/contact" class="nav-link">联系我们</router-link>
        </li>
        <!-- <li class="nav-item" :class="{ 'active': activeNav === 'download' }" @click="setActiveNav('download')">
          <router-link to="/download" class="nav-link">APP下载</router-link>
        </li> -->
      </ul>
      <div class="navbar-right">
        <!-- 登录状态 -->
        <div v-if="isLoggedIn" class="user-profile">  
          <div class="user-avatar">
            <!-- 使用真实头像，如果没有则使用默认头像 -->
            <img v-if="userAvatar" :src="userAvatar" alt="用户头像" class="avatar-image">
            <div v-else class="avatar">{{ userPhone ? userPhone.charAt(0) : '' }}</div>
          </div>
          <div class="user-info">
            <span class="user-phone">{{ userPhone }}</span>
            <span class="logout-btn" @click="logout">退出登录</span>
          </div>
        </div>
        <!-- 未登录状态 -->
        <div v-else class="auth-links">
          <router-link to="/login" class="auth-link">登录</router-link>
          <span class="separator">|</span>
          <router-link to="/login#register" class="auth-link">注册</router-link>
        </div>
        <div class="language-selector">
          <select class="language-dropdown">
            <option value="zh" selected>中文</option>
            <option value="en">EN</option>
          </select>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Images } from '@/utils/imageLoader';
import store from '@/utils/store';

export default {
  name: 'NavbarComponent',
  data() {
    return {
      activeNav: 'home',
      Images,
      userPhone: '',
      userAvatar: ''
    }
  },
  computed: {
    isLoggedIn() {
      return store.state.isLoggedIn;
    }
  },
  watch: {
    $route(to) {
      // 根据当前路由路径更新activeNav
      const path = to.path.replace('/', '')
      if (path) {
        this.activeNav = path
      } else {
        this.activeNav = 'home'
      }
    },
    // 监听登录状态变化
    isLoggedIn(newVal) {
      if (newVal && store.state.user) {
        this.userPhone = store.state.user.nickname || store.state.user.phone;
        this.userAvatar = store.state.user.avatar || '';
      } else {
        // 用户退出登录，清空用户信息
        this.userPhone = '';
        this.userAvatar = '';
      }
    },
    // 监听用户信息变化
    'store.state.user': {
      handler(newVal) {
        if (newVal) {
          this.userPhone = newVal.nickname || newVal.phone;
          this.userAvatar = newVal.avatar || '';
        } else {
          this.userPhone = '';
          this.userAvatar = '';
        }
      },
      deep: true
    }
  },
  mounted() {
    // 组件挂载时根据当前路由设置初始activeNav
    const path = this.$route.path.replace('/', '')
    if (path) {
      this.activeNav = path
    } else {
      this.activeNav = 'home'
    }
    
    // 初始化用户信息
    if (store.state.isLoggedIn && store.state.user) {
      this.userPhone = store.state.user.nickname || store.state.user.phone;
      this.userAvatar = store.state.user.avatar || '';
    }
  },
  methods: {
    setActiveNav(nav) {
      this.activeNav = nav
    },
    // 退出登录
    logout() {
      store.actions.logout();
      this.userPhone = '';
      this.userAvatar = '';
    }
  }
}
</script>

<style scoped>
.navbar {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.container {
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.navbar-logo img {
    width: 200px;
    height: 28px;
}

.navbar-nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  padding: 8px 16px;
  display: block;
}

.nav-link:hover {
  color: #ff6b00;
}

/* Active navigation item styles */
.nav-item.active .nav-link {
  color: #ff6b00;
  font-weight: 600;
}

/* Right side navigation */
.navbar-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Authentication links */
.auth-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.auth-link {
  text-decoration: none;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s;
}

.auth-link:hover {
  color: #ff6b00;
}

.separator {
  color: #ccc;
  font-size: 14px;
}

/* Language selector */
.language-selector {
  position: relative;
}

.language-dropdown {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  outline: none;
  transition: border-color 0.3s;
}

.language-dropdown:hover,
.language-dropdown:focus {
  border-color: #ff6b00;
}

/* 用户信息样式 */
.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ff6b00;
  color: white;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-image {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-phone {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.logout-btn {
  font-size: 12px;
  color: #ff6b00;
  cursor: pointer;
  transition: color 0.3s;
}

.logout-btn:hover {
  color: #ff8533;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .user-phone {
    display: none;
  }
}
</style>